import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import './style.css'; // Import your custom styles
const VnSelectText = ({ lableOptions, valueOptions, listtype, value, onOptionChange, placeHolder, isOpen, onOpen, onClose }) => {
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [inputValue, setInputValue] = useState(value || '');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isDropdownFocusedIndex, setIsDropdownFocusedIndex] = useState(-1);
    const listRef = useRef(null);
    const lastActionRef = useRef(null);
    const [isDisableHoverOnKeyboardNavigation, setIsDisableHoverOnKeyboardNavigation] = useState(false);
    useEffect(() => {
        setInputValue(value || '');
    }, [value]);
    useEffect(() => {
        if (typeof isOpen === 'boolean') {
            setIsDropdownOpen(isOpen);
        }
    }, [isOpen]);
    const handleInputChange = (event) => {
        const inputText = event.target.value;
        setInputValue(inputText);
        if (inputText.trim() === '') {
            setFilteredOptions([]);
            setIsDropdownOpen(false);
            setSelectedOption({
                label: '',
                value: ''
            });
            onOptionChange('', '');
            return;
        }
        const filteredLabelOptions = lableOptions?.filter((option) => option.label.toLowerCase().includes(inputText.toLowerCase())) || [];
        const filteredValueOptions = valueOptions?.filter((option) => option.label.toLowerCase().includes(inputText.toLowerCase())) || [];
        const typedTextOption = { label: inputText, value: '' };
        setFilteredOptions([typedTextOption, ...filteredLabelOptions, ...filteredValueOptions]);
        setIsDropdownOpen(true);
        setIsDropdownFocusedIndex(-1);
    };
    const handleOptionClick = (selectedOption) => {
        setSelectedOption(selectedOption);
        onOptionChange(selectedOption.value.toString(), selectedOption.label);
        setInputValue(selectedOption.label);
        setFilteredOptions([]);
        setIsDropdownOpen(false);
        setIsDropdownFocusedIndex(-1);
    };
    const handleKeyboardNavigation = (event) => {
        if (!isDropdownOpen || filteredOptions.length === 0)
            return;
        lastActionRef.current = 'keyboard';
        setIsDisableHoverOnKeyboardNavigation(true);
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setIsDropdownFocusedIndex(prev => {
                const nextIndex = lastActionRef.current === 'hover' ? 0 : (prev + 1) % filteredOptions.length;
                return nextIndex;
            });
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            setIsDropdownFocusedIndex(prev => {
                const prevIndex = lastActionRef.current === 'hover' ? filteredOptions.length - 1 : (prev - 1 + filteredOptions.length) % filteredOptions.length;
                return prevIndex;
            });
        }
        if (event.key === 'Enter') {
            event.preventDefault();
            if (isDropdownFocusedIndex >= 0) {
                handleOptionClick(filteredOptions[isDropdownFocusedIndex]);
            }
            else {
                onOptionChange(inputValue, inputValue);
                setIsDropdownOpen(false);
            }
        }
        if (event.key === 'Escape') {
            setIsDropdownOpen(false);
            setIsDropdownFocusedIndex(-1);
        }
    };
    const handleInputClick = () => {
        if (!isDropdownOpen) {
            setIsDropdownOpen(true);
            onOpen?.();
        }
    };
    const handleDropdownClose = () => {
        setIsDropdownOpen(false);
        onClose?.();
    };
    useEffect(() => {
        if (listRef.current && isDropdownFocusedIndex >= 0) {
            const activeItem = listRef.current.children[isDropdownFocusedIndex];
            if (activeItem) {
                activeItem.scrollIntoView({ block: 'nearest' });
            }
        }
    }, [isDropdownFocusedIndex]);
    return (_jsxs("div", { className: 'custom-dropdown', children: [_jsx("input", { type: 'text', value: inputValue, onChange: handleInputChange, placeholder: placeHolder, className: 'custom-input form-control vn-Input', onClick: handleInputClick, onKeyDown: handleKeyboardNavigation }), isDropdownOpen && filteredOptions.length > 0 && inputValue.trim() !== '' && (_jsx("ul", { className: 'custom-list', ref: listRef, children: filteredOptions.map((option, index) => (_jsx("li", { className: `custom-item ${isDropdownFocusedIndex === index ? 'focused' : ''}`, onClick: () => {
                        handleOptionClick(option);
                        handleDropdownClose();
                    }, onMouseEnter: () => {
                        if (!isDisableHoverOnKeyboardNavigation) {
                            setIsDropdownFocusedIndex(index);
                            lastActionRef.current = 'hover';
                        }
                    }, onMouseLeave: () => { setIsDisableHoverOnKeyboardNavigation(false); }, children: option.label }, option.value))) }))] }));
};
export default VnSelectText;
